<div class="row dashboard-box-container" [ngClass]="{'h-100': fullHeight}">
    <div class="col-6">
        <div class="blue-box">
            <div class="label">
                <mwp-text-translate [text]='labelOne' [jsonKey]="labelOne" />
            </div>
            <div class="amount">
                {{amountOne}}
            </div>
        </div>
    </div>
    <div class="col-6">
        <div class="red-box">
            <div class="label">
                <mwp-text-translate [text]='labelTwo' [jsonKey]="labelTwo" />
            </div>
            <div class="amount">
                {{amountTwo}}
            </div>
        </div>
    </div>
</div>